import { render, staticRenderFns } from "./BaseScatterChart.vue?vue&type=template&id=66e0c1f2&scoped=true&"
import script from "./BaseScatterChart.vue?vue&type=script&lang=js&"
export * from "./BaseScatterChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e0c1f2",
  null
  
)

export default component.exports